export default __webpack_public_path__ + "static/media/goods.ae8c329f.svg";